import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata-wsp/common/components/stepCircle/StepCircle.less');
const cx = classnames.bind(styles);

export enum StepCircleSize
{
    Small = 'smallSize',
    Medium = 'mediumSize',
    Default = 'defaultSize',
    Large = 'largeSize',
    ExtraLarge = 'extraLargeSize'
}

export enum StepCircleState
{
    Default = 'defaultState',
    Active = 'activeState',
    Passed = 'passedState'
}

export interface IStepCircleProps
{
    text:string;
    className?:string;
    size?:StepCircleSize;
    state?:StepCircleState;
    isDisabled?:boolean;
}

export class StepCircle extends React.Component<IStepCircleProps, any>
{
    public render():JSX.Element
    {
        const {
            className,
            text,
            size = StepCircleSize.Default,
            state = StepCircleState.Default,
            isDisabled
        } = this.props;

        return <div className={cx('stepCircle', className, size, state, {isDisabled})}>
            {
                state === StepCircleState.Passed
                    ? <MDIcon
                        name={MDIcons.common.Checkmark}
                        className={styles.passedIcon}
                        size={size === StepCircleSize.ExtraLarge || size === StepCircleSize.Large
                            ? MDIconSize.medium
                            : MDIconSize.medium16
                        }
                    /> : text
            }
        </div>;
    }
}
